export const Forbidden = {
  // Distinct from every other 403 on purpose. Concierge clears the session and re-runs order lookup
  // on this code; a front-door rejection or an entitlements failure must not do that, or a
  // misconfigured deployment would clear the session and redirect on every single response.
  GUEST_ORDER_MISMATCH: 'guest-order-mismatch',
};
